import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Layers, Loader2 } from 'lucide-react';
import { Layout } from './Home';
import PageHero from '../components/PageHero';
import { listVerticals, resolveFileUrl } from '../services/api';
import { pageImages } from '../data/pages';

const VerticalsPublic = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listVerticals()
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <PageHero
        eyebrow="Our Verticals"
        title="Businesses shaped by decades of expertise."
        description="Explore each of the verticals powering Emerald Corporates — from bullion and corporate finance to capital markets and digital."
        image={pageImages.about}
      />
      <section className="bg-[#e2ede6] py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {loading ? (
            <div className="text-center text-[#0b1a2e]/60">
              <Loader2 className="w-5 h-5 animate-spin inline mr-2" /> Loading verticals…
            </div>
          ) : items.length === 0 ? (
            <div className="bg-white rounded-2xl border border-black/5 p-12 text-center">
              <Layers className="w-10 h-10 mx-auto text-[#0b1a2e]/30 mb-3" />
              <p className="text-[#0b1a2e]/60">Verticals will be published here shortly.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((v) => (
                <Link
                  key={v.id}
                  to={`/verticals/${v.slug}`}
                  className="group bg-white rounded-2xl overflow-hidden border border-black/5 hover:shadow-xl transition-all"
                >
                  <div className="aspect-[16/10] overflow-hidden bg-[#e2ede6]">
                    {v.image_url && (
                      <img
                        src={resolveFileUrl(v.image_url)}
                        alt={v.title}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                      />
                    )}
                  </div>
                  <div className="p-6">
                    {v.eyebrow && (
                      <span className="text-[10px] font-semibold tracking-[0.25em] uppercase text-[#0f5c3d]">{v.eyebrow}</span>
                    )}
                    <h3
                      className="mt-2 text-2xl text-[#0b1a2e] group-hover:text-[#0f5c3d] transition-colors"
                      style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
                    >
                      {v.title}
                    </h3>
                    <p className="mt-2 text-sm text-[#0b1a2e]/70 leading-relaxed line-clamp-3">{v.brief}</p>
                    <div className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#0f5c3d]">
                      Learn more <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
};

export default VerticalsPublic;
